import { combineEpics } from 'redux-observable';

import Api from 'lib/Api';
import ReduxHelper from 'lib/ReduxHelper';
import { DASHBOARD_ACTION_TYPES as AT } from './Dashboard.actions';

export default combineEpics(
  ...ReduxHelper.createDefaultEpics(
    [AT.DASHBOARD_FETCH_DATA, Api.fetchDashboardData],
    [AT.DASHBOARD_READGDPR, Api.readGDPRData]
  )
);
